import React, { useEffect, useState } from 'react';
import SellFundReviewRow from '../../Sell/SellReview/SellFundReviewRow/SellFundReviewRow';
import SellSelectedFundAmount from '../../Sell/SellReview/SellSelectedFundAmount/SellSelectedFundAmount';
import SellTransactionEstimation from '../../Sell/SellReview/SellTransactionEstimation/SellTransactionEstimation';
import './MailCheckToSchool.scss';
import SellTradeDateReviewRow from '../../Sell/SellReview/SellTradeDateReviewRow/SellTradeDateReviewRow';

const MailCheckToSchool = ({
  selectedSchool,
  selectedFunds,
  deliveryMethod,
  studentDetail,
  displayTradeDate,
  isTakeHomeEstimated,
  sellTakeHomeAmount,
  sellTotalAmount,
}) => {
  const [studentName, setStudentName] = useState<string | null>(null);
  const [studentId, setStudentId] = useState<string | null>(null);

  const getStudentFullName = (student) => {
    return `${student.firstName}${
      student.middleName && ' ' + student.middleName
    }${student.lastName && ' ' + student.lastName}${
      student.suffix && ' ' + student.suffix
    }`;
  };

  useEffect(() => {
    if (studentDetail?.student) {
      const student = studentDetail?.student;
      setStudentName(getStudentFullName(student));
      setStudentId(student?.id);
    }
  }, [studentDetail]);
  return (
    <div className="row mail-distribute-review-heading">
      <div className="col-md-5 col-sm-6 college-distribute-review-delivery">
        {selectedSchool ? (
          <>
            <div className="grey-text-header">MAIL CHECK TO</div>
            <div
              className="college-name-style blocked_data"
              data-testid="schoolName"
            >
              {selectedSchool.schoolName}
            </div>
            <div className="address-style" data-testid="address">
              <span
                className="address-lines-review blocked_data"
                data-testid="address-lines"
              >
                {selectedSchool.addressLineOne}
                {selectedSchool.addressLineTwo && (
                  <span>{selectedSchool.addressLineTwo}</span>
                )}
              </span>
            </div>
            <div className="address-style blocked_data">
              <span data-testid="city-state">
                {selectedSchool.city}, {selectedSchool.state}{' '}
              </span>
              <span data-testid="zip-zipExt">
                {selectedSchool.zipExt ? (
                  <span>
                    {selectedSchool.zip}-{selectedSchool.zipExt}
                  </span>
                ) : (
                  <span>{selectedSchool.zip}</span>
                )}
              </span>
            </div>
            <div className="header-styles">
              <span>Student Name: </span>
              <span
                className="value-style blocked_data"
                data-testid="student-name"
              >
                {studentName}
              </span>
            </div>
            <div>
              <span className="header-styles">Student Id: </span>
              <span
                className="value-style blocked_data"
                data-testid="student-id"
              >
                {studentId}
              </span>
            </div>
          </>
        ) : null}
        <div className="margin-allign">
          <SellTransactionEstimation deliveryMethod={deliveryMethod} />
        </div>
      </div>
      <div className="mail-transactions-review-space col-md-7 col-sm-6 col-xs-12">
        {selectedFunds.map((fund, i) => {
          return (
            <div key={i} className="mail-transactions-review-funds-row">
              <SellFundReviewRow deliveryMethod={deliveryMethod} fund={fund} />
              <SellSelectedFundAmount fund={fund} />
            </div>
          );
        })}
      </div>
      <SellTradeDateReviewRow
        deliveryMethod={deliveryMethod}
        displayTradeDate={displayTradeDate}
        isTakeHomeEstimated={isTakeHomeEstimated}
        sellTakeHomeAmount={sellTakeHomeAmount}
        sellTotalAmount={sellTotalAmount}
      />
    </div>
  );
};

export default MailCheckToSchool;
